<template>
  <div>
    <v-card tile flat>
      <v-toolbar
        tile
        card
        flat
        dense
        color="theme_primary"
        class="white--text"
        height="36"
      >
        <v-spacer></v-spacer>
        <v-toolbar-title class="white-text text-capitalize"
          >Invoice</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-side-icon>
          <v-icon color="white">receipt</v-icon>
        </v-toolbar-side-icon>
      </v-toolbar>
      <v-card-text>
        <v-layout my-2 align-center>
          <v-flex py-1 xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">event</v-icon>Invoice
              Date :
            </span>
          </v-flex>
          <v-flex xs6>{{ showedBankInvoice.invoice_date }}</v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>

        <v-layout my-2 align-center>
          <v-flex py-1 xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">store</v-icon
              >Subsidiary :
            </span>
          </v-flex>
          <v-flex xs6>{{
            getNameById(showedBankInvoice.subsidiary_company_id, "companies")
          }}</v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>
        <v-layout my-2 align-center>
          <v-flex py-1 xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">storefront</v-icon>
              {{ companyLabel }} :
            </span>
          </v-flex>
          <v-flex xs6>{{
            showedBankInvoice.company_id
              ? getNameById(showedBankInvoice.company_id, "companies")
              : showedBankInvoice.company_name
          }}</v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>

        <v-layout my-2 align-center>
          <v-flex py-1 xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575"
                >mdi-format-quote-close</v-icon
              >Designation :
            </span>
          </v-flex>
          <v-flex xs6>{{ showedBankInvoice.designation }}</v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>

        <v-layout my-2 align-center>
          <v-flex py-1 xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">mdi-cash</v-icon>Amount
              :
            </span>
          </v-flex>
          <v-flex xs6>{{
            inCurrency(selectedCurrencyCode(), showedBankInvoice.amount)
          }}</v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>

        <v-layout my-2 align-center>
          <v-flex py-1 xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575"
                >mdi-calendar-check</v-icon
              >Expected Payment Date :
            </span>
          </v-flex>
          <v-flex xs6>{{ showedBankInvoice.expected_payment_date }}</v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>

        <v-layout my-2 align-center>
          <v-flex py-1 xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">receipt</v-icon>Invoice
              Number :
            </span>
          </v-flex>
          <v-flex xs6>{{ showedBankInvoice.invoice_number }}</v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>

        <v-layout my-2 align-center>
          <v-flex py-1 xs5 offset-xs1>
            <span style="color: #757575;">
              <v-icon small class="pr-1" color="#757575">attachment</v-icon
              >Document URL :
            </span>
          </v-flex>
          <v-flex xs6>{{ showedBankInvoice.document_url }}</v-flex>
        </v-layout>
        <v-flex class="px-5">
          <v-divider />
        </v-flex>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="close" flat color="red">Close</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import currency from "../../../mixins/currency";

export default {
  name: "invoiceShow",
  mixins: [currency],
  props: {
    showedBankInvoice: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters("commonStore", ["subsidiaries", "getNameById", "currencies"]),
    selectedSubsidiary() {
      var currentSubsidiaryId = this.showedBankInvoice.subsidiary_company_id;

      return this.subsidiaries.find((e) => e.id === currentSubsidiaryId);
    },
    companyLabel() {
      return this.showedBankInvoice.operation_type == "credit"
        ? "Customer"
        : "Supplier";
    },
  },
  methods: {
    selectedCurrencyCode() {
      return this.currencies.find(
        (e) => e.id === this.showedBankInvoice.currency_id
      ).code;
    },
    close() {
      this.$store.commit("contractStore/showBankInvoiceDialog", {
        value: false,
      });
      this.$emit("closeInvoiceDialog");
    },
  },
};
</script>

<style lang="stylus" scoped></style>
